import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { startOfWeek, endOfWeek, format } from 'date-fns';

import { SiTrackPage } from '../../components/si-track-page';
import { InspectionComponent } from './inspection.component';
import { WorkOrdersComponent } from './work-orders.component';
import { OperationManagementStatics } from './operation-management-statics.component';
import { OpeationManagementFilter } from './operation-management-filter.component';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { DateFormat } from '../query-builder/hooks-form-querybuilder/form-date.field.component';
import dayjs from 'dayjs';

const thisWeekDateRange = () => {
  return {
    startDate: dayjs().subtract(2, 'week').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    endDate: dayjs().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
  };
};
export const OperationManagementPage = () => {
  const [managementProps, setManagementProps] = useState<any>({
    fromDate: thisWeekDateRange()?.startDate,
    toDate: thisWeekDateRange()?.endDate,
    workOrderStatusIDs: [],
    dateCriteria: 'created',
    workOrderActiveStatus: 'all'
  });

  const form = useReactHookForm({
    defaultValues: {
      dateCriteria: { dateCriteriaValue: '', dateCriteria: '' },
      workOrderActiveStatus: { statusValue: '', statusLabel: '' },
    },
  });

  const handleSubmit = (filtersData: any) => {
    const filterData = {
      dateCriteria: filtersData?.dateCriteria?.dateCriteriaValue ?? '',
      fromDate: filtersData?.fromDate ? dayjs(filtersData?.fromDate, "MM/DD/YYYY").toISOString() : '',
      toDate: filtersData?.toDate ? dayjs(filtersData?.toDate, "MM/DD/YYYY").toISOString() : '',
      workOrderStatusIDs: filtersData?.workOrderStatusIDs?.map((s: any) => s?.workOrderStatusID) ?? [],
      workOrderActiveStatus: filtersData?.workOrderActiveStatus?.statusValue ?? ''
    }
    setManagementProps(filterData);
  };

  return (
    <SiTrackPage title="Operations Management Queues">
      <Grid container spacing={2}>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <OperationManagementStatics managementArgs={managementProps} />
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <ReactHookForm formName="WORK_ORDER_REPORT_FORM" onSubmit={handleSubmit} formContextProps={form}>
            <OpeationManagementFilter />
          </ReactHookForm>
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <InspectionComponent managementArgs={managementProps} />
        </Grid>
        {/* <Grid item lg={12} sm={12} xl={12} xs={12}>
          <WorkOrdersComponent managementArgs={managementProps} />
        </Grid> */}
      </Grid>
    </SiTrackPage>
  );
};
